// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","703":"LazyIdentificationBusinessForm","886":"LazyInvitationStep","954":"LazyBusinessInfoFormComponent"}[chunkId] + "." + {"99":"1831979733d29aae70a1","703":"b7b2234f0693f02f7ddf","886":"c8ed2da648854fa324a5","954":"a7d8fbfbd7ac58733abb"}[chunkId] + ".js";
};